import React from 'react';
import DriverDashboard from '../Components/Driver/DriverDashboard';

function DriverDashboardPage() {
  return (
    <>
      <DriverDashboard />
    </>
  );
}

export default DriverDashboardPage;
